/**
 * Created by gusenlin on 2017/10/27.
 * 用来调用审批流相应接口
 */

import { fetch, fetchByBrowseHttp } from 'utils/fetch';
import { revertGetParams } from 'utils/indexV2';
import { getQueryString, isIOS } from 'utils/environment';
import { Base64 } from 'js-base64';

class WorkflowService {
  constructor() {
    return this;
  }

  //获取加签的配置
  getSignConfig(companyOID, formOID, counterSignType) {
    return fetch({
      url:
        '/api/countersign/addSign/enable?companyOID=' +
        companyOID +
        '&formOID=' +
        formOID +
        '&counterSignType=' +
        counterSignType,
      method: 'GET',
      nativeResponseSerializer: 'boolean',
    });
  }

  wechatMonitor({ companyOID, formOID, counterSignType, entityType, approverOID, entityOID }) {
    if (getQueryString('loginType') === 'wx' && isIOS()) {
      let data = {
        companyOID: companyOID,
        formOID: formOID,
        counterSignType: counterSignType,
        approverOID,
        entityOID,
        entityType,
      };
      fetch({
        url: '/api/countersign/addSign/enable/and/scope/v2',
        method: 'POST',
        data: {
          approvalCiphertext: Base64.encode(JSON.stringify(data)),
        },
      });
    }
    /*let xmlHttp = new XMLHttpRequest();
    xmlHttp.open('POST', '/api/countersign/addSign/enable/and/scope?1=1', true);
    xmlHttp.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
    xmlHttp.setRequestHeader('Authorization', 'Bearer' + store.getters.getUserToken.access_token);
    xmlHttp.send(JSON.stringify(data));
     */
  }

  //获取加签的配置
  getSignConfigV2({ companyOID, formOID, counterSignType, entityType, approverOID, entityOID }) {
    //this.wechatMonitor({ companyOID, formOID, counterSignType, entityType, approverOID, entityOID });
    return fetch({
      url: '/api/countersign/addSign/enable/and/scope',
      method: 'POST',
      data: {
        companyOID: companyOID,
        formOID: formOID,
        counterSignType: counterSignType,
        approverOID,
        entityOID,
        entityType,
      },
    });
  }

  //获取加签的配置
  getCustomFormsInfo(formOID) {
    return fetch({
      url: '/api/custom/forms/' + formOID,
      method: 'GET',
    });
  }

  getSignEnable(customFormPropertyMap) {
    return (
      customFormPropertyMap &&
      (customFormPropertyMap.countersignType == 1 || customFormPropertyMap.countersignType == 2)
    );
  }

  getSignPriority(customFormPropertyMap) {
    return (
      !customFormPropertyMap || !customFormPropertyMap.countersignType || customFormPropertyMap.countersignType == 2
    );
  }

  //获取快捷回复列表
  getRejectReply() {
    return fetch({
      url: '/api/quick/reply',
      method: 'GET',
    });
  }
  // 获取审核快捷回复
  getAuditRejectReply(params) {
    return fetch({
      url: '/api/audit/quick/reply',
      method: 'GET',
      params,
    });
  }

  //删除快捷回复
  deleteRejectReply(quickReplyOIDs) {
    return fetch({
      url: '/api/quick/reply',
      method: 'DELETE',
      params: { quickReplyOIDs: quickReplyOIDs },
    });
  }
  // 删除审批快捷回复
  deleteAuditRejectReply(params) {
    return fetch({
      url: '/api/audit/quick/reply',
      method: 'DELETE',
      params,
    });
  }

  //添加快捷回复
  postRejectReply(reply) {
    return fetch({
      url: '/api/quick/reply',
      method: 'POST',
      data: reply,
    });
  }
  //审核 添加快捷回复
  postAuditRejectReply(data) {
    return fetch({
      url: '/api/audit/quick/reply',
      method: 'POST',
      data,
    });
  }

  //批量审批和驳回
  postApprovalsAddReject(url, data) {
    return fetch({
      url: url,
      method: 'POST',
      data: data,
    });
  }

  // 审批列表页批量审批或驳回
  postBulkOperate(type, data) {
    let url = type === 'reject' ? '/api/approvals/reject' : '/api/approvals/batch/pass';
    return fetch({
      url,
      method: 'POST',
      data,
    });
  }

  // 单据详情页审批或驳回
  postOperate(type, data) {
    let url = type === 'reject' ? '/api/approvals/reject' : '/api/approvals/pass';
    return fetch({
      url,
      method: 'POST',
      data,
    });
  }

  //获取待还款金额
  getLoanAmount(userOID, companyOID, statusList1, statusList2) {
    return fetch({
      url:
        '/api/loan/application/user/debt/amount?userOID=' +
        userOID +
        '&companyOID=' +
        companyOID +
        '&statusList=' +
        statusList1 +
        '&statusList=' +
        statusList2,
      method: 'GET',
    });
  }

  // 筛选审批列表
  /**
   * entityType 可选  Integer 单据类型(1001:申请单，1002:报销单) 允许值: 1001, 1002
   * finished 可选  Boolean   是否已审批
   * minAmount 可选  BigDecimal  最小金额
   * maxAmount 可选  BigDecimal 最大金额
   * businessCode 可选  String 业务单据号，模糊查询
   * formOIDs 可选  List  表单OID列表
   * departmentOIDs 可选 List  部门OID
   * applicantOIDs 可选  List 申请人OID列表
   * beginDate 可选  String 开始日期,yyyy-MM-dd,eg:2018-04-12
   * endDate 可选  String  结束日期
   * searchMode 可选  Integer   1:本人+代理，2：本人，3：代理
   * page 可选  int   页码，从0开始
   * size 可选  int   每页条数
   * related 与我相关查询
   * v3接口 列表查询优化
   */
  getApprovalBatchFilters(params, data) {
    let url = '/api/approvals/batchfilters/v4';
    let paramsUrl = revertGetParams(params);
    return fetch({
      url: url + paramsUrl,
      method: 'POST',
      data: data,
    });
  }

  //筛选审批列表 需改
  getFilterApprovalList(url, params) {
    return fetch({
      url: url,
      method: 'GET',
    });
  }

  //获取审批列表
  getApprovals(params) {
    return fetch({
      url: '/api/approvals',
      method: 'GET',
      params: params,
    });
  }

  //获取审批列表 需改
  getApprovalList(url) {
    return fetch({
      url: url,
      method: 'GET',
    });
  }

  /**
   * 查询审批数据中的单据类型, 返回结果根据表单名称分组，无分页
   * @params finished Boolean 单据状态，是否已审批
   * @params entityType  Number 单据类型 1001申请单，1002报销单
   */
  getApprovalsCustomForms(finished, entityType) {
    return fetch({
      url: '/api/approvals/custom/form',
      method: 'GET',
      params: {
        finished,
        entityType,
      },
    });
  }
  /**
   * 查询审批数据中的单据类型, 返回结果根据表单名称分组，无分页
   * @params finished Boolean 单据状态，是否已审批
   * @params corporateFlag Boolean 是否是对公单据
   */
  getApprovalsCustomFormsv3(finished, corporateFlag, related) {
    return fetch({
      url: '/api/approvals/custom/form/v3',
      method: 'GET',
      params: {
        finished,
        corporateFlag,
        related,
      },
    });
  }

  //模糊搜索部门
  getDepartmentList(flag, name) {
    return fetch({
      url: '/api/department/like',
      method: 'GET',
      params: {
        flag: flag,
        name: name,
      },
    });
  }

  //费用驳回
  postRejectInvoice(data) {
    return fetch({
      url: '/api/approvals/reject/expensereport/invoice',
      method: 'POST',
      data,
    });
  }

  //差标校验
  postCheckStandard(data) {
    return fetch({
      url: '/api/travel/standard/results',
      method: 'POST',
      data: {
        data,
      },
    });
  }

  // 员工回复财务通知
  /*
   *   postData: 提交的数据
   *   billOID: 报销单OID
   *   remark: 员工回复
   *   businessCode: 报销单号
   *   toUserOID: 被回复人OID
   *   fromUserOID: 回复人OID
   *   type： 回复类型 1001 财务通知 1002员工回复
   * */
  postToRelpyBillComment({
    billOID,
    remark,
    businessCode,
    toUserOID,
    fromUserOID,
    type,
    attachmentOIDList,
    replyMode,
  }) {
    return fetch({
      url: '/api/billcomment',
      method: 'POST',
      data: {
        billOID,
        remark,
        businessCode,
        toUserOID,
        fromUserOID,
        type,
        attachmentOIDList,
        replyMode,
      },
    });
  }

  // 员工回复财务发票袋通知
  postToReplyBagComment(data) {
    return fetch({
      url: '/api/expense/reports/bag/staff/reply',
      method: 'POST',
      data,
    });
  }

  //获取审批意见信用信息
  getApprovalCondition({ replyId, applicantOID, jobId }) {
    //applicantOID
    return fetch({
      url: '/api/credit/reply/condition',
      method: 'GET',
      params: { replyId, applicantOID, jobId },
    });
  }

  //审批中标记创建、查询接口
  signApproving(data) {
    return fetch({
      url: '/api/approval/' + data.entityOID + '/flag',
      method: 'POST',
      params: {
        userOID: data.userOID,
        approverOID: data.approverOID,
      },
    });
  }

  /**
   * 获取审批人可编辑字段
   * @param formOID
   * @param entityType
   * @param entityOID
   * @param approvalOID
   * @returns {*}
   */
  getApproverEditForm({ formOID, entityType, entityOID, approvalOID }) {
    return fetch({
      url: '/api/approval/custom/form',
      method: 'GET',
      params: {
        formOID,
        entityType,
        entityOID,
        approvalOID,
      },
    });
  }

  /**
   *
   * @param data
   * @example
   *  {
   *      "entityOID":"0fb5fa1a-e3ec-4344-ab92-f93b380283a5",
   *      "entityType":1001,
   *      "approvalOID":"458e6696-97b5-4e95-b6f1-2a6bc3fce81d",
   *      "customFormValueDTOs":[
   *          {
   *              "formValueOID":"3b61b832-f5ec-4353-8fd2-035da94f54e8",
   *              "value":"编辑事由1"
   *          }
   *      ]
   *  }
   * @returns {*}
   */
  postApproverEditForm(data) {
    return fetch({
      url: '/api/approval/edit',
      method: 'POST',
      data,
    });
  }

  // 暂挂
  postApprovalsPending(data) {
    return fetch({
      url: '/api/approvals/pending',
      method: 'POST',
      data,
    });
  }

  //驳回 通过全部单据
  postApprovalAllDoc(params, data) {
    let paramsUrl = revertGetParams(params);
    return fetch({
      url: '/api/approvals/batch/operate' + paramsUrl,
      method: 'POST',
      data,
    });
  }

  //查看未来节点
  postNextApprovalAll(data) {
    return fetch({
      url: '/api/approvals/next/all/ruleApprovalNodeOID',
      method: 'POST',
      data,
    });
  }

  postTransmitApproval(data) {
    return fetch({
      url: '/api/approvals/transmit',
      method: 'POST',
      data,
    });
  }

  //向前加签
  postApprovalCountersign(data) {
    return fetch({
      url: '/api/approvals/countersign',
      method: 'POST',
      data,
    });
  }

  getApproveNodeName(data) {
    return fetch({
      url: '/brms/api/rule/approval/batch/node/name',
      method: 'POST',
      data,
    });
  }

  postSendNotication(data) {
    return fetch({
      url: '/api/approval/approver/send/notice',
      method: 'POST',
      data,
    });
  }

  // 员工回复通知
  postToRelpyApproveComment(data) {
    return fetch({
      url: '/api/approval/comment',
      method: 'POST',
      data,
    });
  }

  // 员工评论
  postToDiscuss(data) {
    return fetch({
      url: '/api/approval/discuss',
      method: 'POST',
      data,
    });
  }

  //获取选人审批人
  postToDesignateNodeUser(data) {
    return fetch({
      url: '/api/approval/designate/node/user',
      method: 'POST',
      data,
    });
  }

  //获取指派用户节点数据
  postDesignateNodeList(data) {
    return fetch({
      url: '/api/approval/designate/submit/user',
      method: 'POST',
      data,
      timeout: 600000,
    });
  }

  //获取是否可指派
  postIsDesignate(data) {
    return fetch({
      url: '/api/approval/designate/show',
      method: 'POST',
      data,
    });
  }

  //保存选人审批人
  postSaveDesignateNodeUser(data) {
    return fetch({
      url: '/api/approval/designate/submit/user/save',
      method: 'POST',
      data,
    });
  }

  //是否符合取消审批条件
  showApporvalCancel(data) {
    return fetch({
      url: '/api/approval/cancel/show',
      method: 'POST',
      data,
    });
  }

  //取消审批操作
  approvalCancel(data) {
    return fetch({
      url: '/api/approval/cancel',
      method: 'POST',
      data,
    });
  }

  //获取签名图片
  getSignatureImg() {
    return fetch({
      url: '/api/approvals/signature',
      method: 'GET',
    });
  }

  //保存签名图片
  saveSignatureImg(data) {
    return fetch({
      url: '/api/approvals/signature',
      method: 'POST',
      data,
    });
  }

  //上传图片
  uploadImage(data) {
    return fetch({
      url: '/api/upload/attachment',
      method: 'POST',
      data,
    });
  }

  //上传图片（iOS浏览器跨域版本）
  uploadImageWithBrowse(data) {
    return fetchByBrowseHttp({
      url: '/api/upload/attachment',
      method: 'POST',
      data,
    });
  }

  //上传图片（base64b版本）
  uploadImageWithBase64(attachmentType, data) {
    return fetch({
      url: '/api/upload/attachment/v3',
      method: 'POST',
      params: {
        attachmentType,
      },
      data,
    });
  }

  //审批评论支持两分钟内撤回
  replyInWithdraw(historyId) {
    return fetch({
      url: '/api/approval/discuss/withdraw',
      method: 'POST',
      data: {
        historyId,
      },
    });
  }

  // 驳回处理可选的方式
  getRejectOptions() {
    return fetch({
      url: '/api/approval/reject/type',
      method: 'GET',
    });
  }

  //员工催办
  changeApprovalUrge(data) {
    return fetch({
      url: '/api/approval/remind/staff/urge',
      method: 'POST',
      data,
      nativeResponseSerializer: 'boolean',
    });
  }

  //获取审批编辑节点修改的内容
  getApprovalEditHistory(id) {
    return fetch({
      url: `/api/approval/edit/operation/history?approvalHistoryId=${id}`,
      method: 'GET',
    });
  }

  //获取审批编辑节点修改的内容
  getSupplierEditHistory(id) {
    return fetch({
      url: `/api/vendor/info/operation/history?approvalHistoryId=${id}`,
      method: 'GET',
    });
  }

  getLoanChangeHistory(params) {
    return fetch({
      url: '/api/loanBill/operation/history',
      method: 'GET',
      params,
    });
  }
  // 获取视图
  // approve-list-approving-corporate 待审批员工业务
  // approve-list-approving-personnel 待审批对公业务
  // approve-list-approving 待审批
  // approve-list-approved 已审批
  // approve-list-transfer 抄送我的
  getTableviewList(tableName) {
    return fetch({
      url: `/api/tableview/list?tableName=${tableName}&client=app`,
      method: 'GET',
    });
  }

  getBudgetOperationHistory(id) {
    return fetch({
      url: `/api/budget/journals/operation/history?approvalHistoryId=${id}`,
      method: 'GET',
    });
  }

  getRequestOperationHistory(id) {
    return fetch({
      url: `/api/application/operation/history?approvalHistoryId=${id}`,
      method: 'GET',
    });
  }

  // 审批列表页批量异步审批
  handleBatchAsyncApprove(type, data) {
    let url = type === 'reject' ? '/api/approvals/async/reject' : '/api/approvals/async/batch/pass';
    return fetch({
      url,
      method: 'POST',
      data,
      timeout: 60000,
    });
  }

  // 详情页异步审批
  handleAsyncApprove(type, data) {
    let url = type === 'reject' ? '/api/approvals/async/reject' : '/api/approvals/async/pass';
    return fetch({
      url,
      method: 'POST',
      data,
      timeout: 60000,
    });
  }

  // 获取用户操作默认值，审批加签：APPROVAL_SIGN，驳回操作：REJECT_TYPE
  getDefaultOpration(operationKey) {
    return fetch({
      url: `/api/approval/query/user/operation?operationKey=${operationKey}`,
      method: 'GET',
    });
  }

  // 设置用户操作默认值
  setDefaultOpration(data) {
    return fetch({
      url: 'api/approval/user/operation',
      method: 'POST',
      data,
    });
  }

  // 审批助手详情
  getAssistantDetail(data) {
    return fetch({
      url: 'api/approval/assistant/query/document/rule',
      method: 'POST',
      data,
    });
  }

  // 编辑中单据流程预览
  previewAllWorkflow(data) {
    return fetch({
      url: 'api/approval/submit/next/all/ruleApprovalNodeOID',
      method: 'POST',
      data,
    });
  }

  /**
   * 获取AI坐席结果
   * @param entityId
   * @param ruleReportType 适用单据类型，expense_report：报销与对公单据，contract：合同
   * @returns {*}
   */
  getAgentReviewStatus(entityId, ruleReportType) {
    return fetch({
      url: '/api/ai/agent/review/robot/status',
      method: 'GET',
      params: { entityId, ruleReportType },
    });
  }

  // 查询单据更新记录
  getUpdateDataHistory(params) {
    return fetch({
      url: '/api/approvals/node/update/history',
      method: 'GET',
      params,
    });
  }

  // 获取部门预算信息
  getUnitBudgetResult(params) {
    return fetch({
      url: '/budget-service/api/budget/balance/query/results/budget/unit/balance/query',
      method: 'GET',
      params,
    });
  }

  /**
   * 差旅出行助手
   * 查询用户出差天数按月分布和行程城市
   * @param data
   * @returns {*}
   */
  getTravelDaysCities(data) {
    const { startDate, endDate, ...restData } = data;
    return fetch({
      url: `/api/travel/application/user/days/citys?startDate=${startDate}&endDate=${endDate}`,
      method: 'POST',
      data: restData.applicantOID,
    });
  }

  // 获取意见必填配置
  getTxtRequiredTypes(params) {
    return fetch({
      url: '/api/approval/node/info',
      method: 'GET',
      params,
    });
  }

  /**
   * 获取审核意见
   * @param entityId 单据id
   * @param operationType 生成智能审核意见操作类型，abnormal_expense_info：异常费用信息，audit_reject_opinion：审核驳回意见
   * @param operationEntrance 生成智能审核结果操作入口，quick_reply:快捷回复，approval_copilot:审批助手(默认)
   */
  getAiAuditOpinion(entityId, operationType, operationEntrance = 'approval_copilot') {
    return fetch({
      url: '/api/ai/agent/generate/audit/opinion',
      method: 'GET',
      params: { entityId, operationType, operationEntrance },
    });
  }

  /**
   * @description: 审批助手点赞评论
   * @param {*} data 入参
   * @return {*}
   */
  setAssistantFeedback(data) {
    return fetch({
      url: '/api/approval/assistant/feedback',
      method: 'POST',
      data,
    });
  }

  //获取节点分摊配置
  getNodeApportionConfig(entityOID, entityType, approverOID) {
    const params = {
      entityOID,
      entityType,
      approverOID: approverOID || undefined,
    };
    return fetch({
      url: '/api/approval/node/apportionment/permission',
      method: 'GET',
      params,
    });
  }

  // 获取审批职责
  getResponsibilityDescribe(entityOID, entityType, approverOID) {
    const params = {
      entityOID,
      entityType,
      approverOID: approverOID || undefined,
    };
    return fetch({
      url: '/api/approval/node/responsibility',
      method: 'GET',
      params,
    });
  }
}

export default new WorkflowService();
